/**
 * Instrumentation Perf scenario names
 */
export const instrumentationPerfScenarios = {
    AppBootstrap: "AppBootstrap",
    TimeToFirstFullRender: "TimeToFirstFullRender",
    ServiceAPICall: "ServiceAPICall",
    ScheduleRender: "ScheduleRender",
    ScrollTestFPSMeasurement: "ScrollTestFPSMeasurement",
    GetAuthTokenComplete: "GetAuthTokenComplete",
    AuthStart: "AuthStart",
    TeamsAuthComplete: "TeamsAuthComplete",
    TeamsAuthFailures: "TeamsAuthFailures",
    TeamSkypeTokenFailure: "TeamSkypeTokenFailure",
    InitializeInstrumentationService: "InitializeInstrumentationService",
    DeleteSchedule: "DeleteSchedule",
    ClientPermissionSync: "ClientPermissionSync"
};
